import { Button, Div, IconText } from "trunx";
import { ReactNode } from "react";

import BookmarkStar from "./BookmarkStar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ISensor } from "../models/Sensors";
import { useRootStore } from "../models/Root";

interface ILeafletPanelHeadingProps {
  title: string | ReactNode;
  close: () => void;
}

export const LeafletPanelHeading = ({
  title,
  close,
}: ILeafletPanelHeadingProps) => {
  return (
    <Div bulma="level">
      <Div bulma={["level-left", "is-clipped"]}>
        <Div bulma="level-item">{title}</Div>
      </Div>
      <Div bulma="level-right">
        <Button
          className="panel-close"
          bulma={["is-pulled-right", "has-text-white", "is-ghost"]}
          onClick={close}
        >
          <FontAwesomeIcon icon="times" />
        </Button>
      </Div>
    </Div>
  );
};

interface ILeafletSensorPanelHeadingProps {
  sensor: ISensor;
  action?: "close" | "back";
}

export const LeafletSensorPanelHeading = ({
  sensor,
  action = "close",
}: ILeafletSensorPanelHeadingProps) => {
  const {
    sensors: { clearSensor, setSensor },
  } = useRootStore();

  const onClick =
    action === "close" ? clearSensor : () => setSensor(sensor, "summary", true);

  return (
    <div className="panel-heading">
      <Div bulma="level">
        <Div bulma={["level-left", "is-clipped"]}>
          <Div bulma="level-item">
            <IconText>
              <BookmarkStar sensor={sensor} />
            </IconText>
            <span style={{ paddingLeft: "1rem" }}>{sensor.site}</span>
          </Div>
        </Div>
        <Div bulma="level-right">
          <Div bulma="level-item" style={{ paddingLeft: "1ch" }}>
            <Button
              className="sensor-panel-close"
              bulma={["has-text-white", "is-ghost"]}
              onClick={onClick}
            >
              <FontAwesomeIcon icon="times" />
            </Button>
          </Div>
        </Div>
      </Div>
    </div>
  );
};

interface LeafletPanelBodyProps {
  children: ReactNode;
  isFullHeight?: boolean;
  minHeight?: string;
}

export const LeafletPanelBody = ({
  children,
  isFullHeight,
  minHeight,
}: LeafletPanelBodyProps) => {
  let style: React.HTMLAttributes<HTMLDivElement>["style"] = {};
  if (isFullHeight) {
    style["height"] = "80vh";
  } else if (minHeight) {
    style["minHeight"] = minHeight;
  }
  return (
    <div style={style} className="panel-body">
      {children}
    </div>
  );
};
